angular.module('invoice')
    .controller('InvoiceWorkflowConfigurationController', function ($uibModalInstance, InvoiceWorkflow) {
        this.$onInit = () => {
            this.loading = true
            this.showReturnTransitions = false
            InvoiceWorkflow.load()
                .then(configuration => {
                    this.configuration = configuration
                    this.graph = buildGraph(configuration)
                    this.agreementOrAssignmentLimits = Object.keys(configuration.agreementOrAssignment.bypassBelowGross)
                        .sort()
                        .map(currency => ({
                            currency: currency,
                            amount: configuration.agreementOrAssignment.bypassBelowGross[currency]
                        }))
                })
                .finally(() => this.loading = false)
        }

        this.close = () => $uibModalInstance.dismiss('Canceled')

        function buildGraph(configuration) {
            const nodeX = 205
            const nodeWidth = 210
            const nodeHeight = 36
            const rowHeight = 56
            const top = 20
            const statusIndexes = configuration.statuses.reduce((indexes, status, index) => {
                indexes[status] = index
                return indexes
            }, {})
            const nodes = configuration.statuses.map((status, index) => ({
                status: status,
                x: nodeX,
                y: top + index * rowHeight,
                width: nodeWidth,
                height: nodeHeight,
                initial: status === configuration.initialStatus,
                terminal: configuration.terminalStatuses.includes(status)
            }))
            const edges = []

            configuration.statuses.forEach(source => {
                const sourceIndex = statusIndexes[source]
                const targets = configuration.transitions[source] || []
                targets.forEach(target => {
                    const targetIndex = statusIndexes[target]
                    if (targetIndex == null || targetIndex === sourceIndex) return

                    const distance = Math.abs(targetIndex - sourceIndex)
                    const sourceNode = nodes[sourceIndex]
                    const targetNode = nodes[targetIndex]
                    const returnTransition = targetIndex < sourceIndex
                    let path

                    if (!returnTransition && distance === 1) {
                        const centerX = nodeX + nodeWidth / 2
                        path = `M ${centerX} ${sourceNode.y + nodeHeight} L ${centerX} ${targetNode.y}`
                    } else if (returnTransition) {
                        const routeX = nodeX - 28 - (distance - 1) * 18
                        const sourceY = sourceNode.y + nodeHeight / 2
                        const targetY = targetNode.y + nodeHeight / 2
                        path = `M ${nodeX} ${sourceY} C ${routeX} ${sourceY}, ${routeX} ${targetY}, ${nodeX} ${targetY}`
                    } else {
                        const nodeRight = nodeX + nodeWidth
                        const routeX = nodeRight + 28 + (distance - 2) * 18
                        const sourceY = sourceNode.y + nodeHeight / 2
                        const targetY = targetNode.y + nodeHeight / 2
                        path = `M ${nodeRight} ${sourceY} C ${routeX} ${sourceY}, ${routeX} ${targetY}, ${nodeRight} ${targetY}`
                    }

                    edges.push({
                        source: source,
                        target: target,
                        path: path,
                        returnTransition: returnTransition
                    })
                })
            })

            return {
                width: 620,
                height: top * 2 + Math.max(0, nodes.length - 1) * rowHeight + nodeHeight,
                nodes: nodes,
                edges: edges,
                returnTransitionsCount: edges.filter(edge => edge.returnTransition).length
            }
        }
    })
